interface PublishableForm {
    form_name: string | null;
    score_engine: string | null;
    score_engine_config: unknown;
    pages: Array<{
        page_label: string | null;
        inputs: Array<{
            input_key: string;
            input_label: string | null;
            min_value?: number | null;
            max_value?: number | null;
            options?: string[] | null;
            scale_options?: unknown;
            /** A dictionary supplies the choices, so the input needs no options of its own. */
            dictionary_id?: string | null;
        }>;
    }>;
}

const CHOICE_KEYS = new Set(["single-choice", "multiple-choice", "dropdown"]);

export function validateFormForPublish(form: PublishableForm): string[] {
    const errors: string[] = [];
    if (!form.form_name?.trim()) errors.push("The form needs a name.");
    if (form.pages.length === 0) errors.push("Add at least one page.");

    const inputs = form.pages.flatMap((page) => page.inputs);
    if (inputs.length === 0) errors.push("Add at least one question.");
    form.pages.forEach((page, index) => {
        if (!page.page_label?.trim()) errors.push(`Page ${index + 1} needs a title.`);
    });
    inputs.forEach((input, index) => {
        const label = input.input_label?.trim() || `Question ${index + 1}`;
        if (!input.input_label?.trim()) errors.push(`${label} needs a label.`);
        if (
            (input.input_key === "number" || input.input_key === "slider") &&
            input.min_value != null &&
            input.max_value != null &&
            input.max_value <= input.min_value
        ) {
            errors.push(`${label}: the maximum must be greater than the minimum.`);
        }
        const hasDictionary = input.dictionary_id != null;
        if (CHOICE_KEYS.has(input.input_key) && !hasDictionary && !input.options?.some((option) => option.trim())) {
            errors.push(`${label} needs at least one option.`);
        }
        if (
            input.input_key === "scale-rating" &&
            !hasDictionary &&
            (!Array.isArray(input.scale_options) || input.scale_options.length === 0)
        ) {
            errors.push(`${label} needs at least one scale option.`);
        }
    });

    if (
        form.score_engine != null &&
        (typeof form.score_engine_config !== "object" || form.score_engine_config == null)
    ) {
        errors.push("The calculator is not fully configured.");
    } else if (form.score_engine === "sum_total") {
        const config = form.score_engine_config as Record<string, unknown>;
        if (typeof config.output_input_id !== "string" || !Array.isArray(config.source_input_keys)) {
            errors.push("The Total calculator is not fully configured.");
        }
    }

    return errors;
}
